<template>
  <section class="max-w-5xl mx-auto px-4 py-10">
    <h2 class="text-3xl font-bold mb-4">Wanna see what I can do?</h2>
    <p class="text-gray-600 mb-10">
      Here’s a glimpse into some of the tools, systems, and experiments I’ve built across trading, automation, and the web.
      Every project taught me something — and chances are, they’ll do something useful for you too.
    </p>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <ProjectCard
        v-for="(proj, index) in projects"
        :key="index"
        :title="proj.title"
        :description="proj.description"
        :thumbnail="proj.thumbnail"
        :tech="proj.tech"
        @click="openModal(index)"
        class="opacity-0 animate-fadeInUp"
      />
    </div>

    <ProjectViewModal
      v-if="selectedProject"
      :project="selectedProject"
      @close="selectedProject = null"
    />

    <CTA
      heading="Like what you saw?"
      subtext="Let’s build your next system — built to spec, built to perform."
      buttonText="Talk to Me on Telegram"
      bg="bg-gray-50"
      textColor="text-gray-900"
      subTextColor="text-gray-600"
      btnClass="bg-black text-white border-black hover:bg-gray-800 hover:border-gray-800"
    />
  </section>
</template>

<script>
import ProjectCard from '@/components/ProjectCard.vue';
import ProjectViewModal from '@/modals/ProjectViewModal.vue';
import CTA from '@/components/CTA.vue';

export default {
  name: 'ProjectPage',
  components: {
    ProjectCard,
    ProjectViewModal,
    CTA
  },
  data() {
    return {
      selectedProject: null,
      projects: [
        {
          title: 'Gap Strategy EA with Telegram Alerts',
          description: 'An MT5 tool that scans for Fair Value Gaps and divergence, and sends alerts to Telegram in real-time based on custom trading conditions being met',
          thumbnail: '/images/fvg-thumbnail.png',
          imageUrl: '',
          videoUrl: 'https://res.cloudinary.com/dtkxnnoto/video/upload/v1752135063/Gap-New_vcnsh3.mp4',
          tech: ['mql5', 'telegram']
        },
        {
          title: 'TradingView Divergence Detector',
          description: 'A Pine Script that marks divergence directly on TradingView charts and alerts the user.',
          thumbnail: '/images/divergence-thumbnail.jpg',
          imageUrl: '',
          videoUrl: 'https://res.cloudinary.com/dtkxnnoto/video/upload/v1752135059/Pine-Divergence-New_qbm5ds.mp4',
          tech: ['pine']
        },
        {
          title: 'Swing Point Class for MT5',
          description: 'A reusable MQL5 class that detects swing highs and lows using local candle structure. Forms the basis for break of structure and confirmation logic in the Gap Strategy EA.',
          thumbnail: '/images/swing-thumbnail.PNG',
          imageUrl: '/images/swing.PNG',
          tech: ['mql5']
        },
        {
          title: 'Divergence Detection for MT5',
          description: 'Adapted from a TradingView script, this MQL5 implementation detects bullish and bearish divergences with precision and integrates it into the Gap Strategy EA for higher confidence alerts.',
          thumbnail: '/images/divergence-thumbnail.jpg',
          imageUrl: '/images/divergence.PNG',
          videoUrl: '',
          tech: ['mql5']
        }
      ]
    };
  },
  methods: {
    openModal(index) {
      this.selectedProject = this.projects[index];
    }
  }
};
</script>
